/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { offEvent, onEvent } from "@adapptio/lib-shared";
import React, { FC, useEffect, useState } from "react";
import { ResourcePathBreadcrumbs } from "../../../../ui/components/ResourcePathBreadcrumbs";
import { AssetEdit } from "../AssetEdit";

export interface IAssetSecondaryToolbarProps {
	view: AssetEdit;
}

export const AssetSecondaryToolbar: FC<IAssetSecondaryToolbarProps> = ({ view }) => {
	const [ resourceInfo, setResourceInfo ] = useState(() => view.getResourceInfo());

	useEffect(() => {
		const handleResourceInfoChange = () => setResourceInfo(view.getResourceInfo());

		onEvent(view.onResourceInfoChanged, handleResourceInfoChange);

		return () => {
			offEvent(view.onResourceInfoChanged, handleResourceInfoChange);
		};
	}, [ view ]);

	return (
		<ResourcePathBreadcrumbs
			parentList={resourceInfo.parentList}
			resourceName={resourceInfo.resource?.descriptor?.name}
			resourceId={resourceInfo.resource?.id}
			maxVisibleCrumbs={12}
		/>
	);
};
